/**
 * Formats a Date object into 'MM/dd/yyyy' string as expected by the API.
 * Returns null if the date is null or invalid.
 * @param {Date | null} date - The date object to format.
 * @returns {string | null} - Formatted date string or null.
 */
export const formatDateParam = date => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return null;
  }
  // Using native methods to format as MM/dd/yyyy
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};
